export const HIDE_REMOVE_ICON: any = ['profilePicture', 'details', 'shortBio'];
export const HIDE_SAVE_BUTTON: any = ['profilePicture'];
